<template>
  <el-dialog
    :title="$t('text_ventas_exportarMisVentas')"
    :visible.sync="dialogVisible"
    width="20%"
    :modalAppendToBody="false"
  >
    <div
      class="py-5 px-6 flex flex-col items-center shadow-lg border rounded-lg border-gray-200"
    >
      <img
        loading="lazy"
        src="https://img.komercia.store/komerciaacademico/image/upload/q_auto,f_auto/v1649276085/2264789_x9nlrl.png"
        alt="icon export"
        width="140"
      />
      <h1 class="text-xl font-bold mt-5">
        {{ $t("text_ventas_descargar") }}
      </h1>
      <p class="text-center text-sm mt-2 text-gray-400">
        Descarga un listado de tus ordenes en Komercia. Puedes descargarlo en
        formato
      </p>

      <el-button
        class="btn_export"
        :loading="isExporting"
        @click="exportOrden()"
      >
        {{ isExporting ? "Descargando..." : "Descargar archivo" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "salesExport",
  props: {
    visible: Boolean,
    storeData: Object,
  },
  data() {
    return {
      isExporting: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(newValue) {
        this.$emit("update:visible", newValue);
      },
    },
  },
  methods: {
    async exportOrden() {
      this.isExporting = true;
      try {
        const response = await axios({
          method: "GET",
          url: `${this.$configKomercia.urlKomerciaAWS}/api/v1/sales/admin/export`,
          headers: this.$store.state.configAxios.headers,
          params: { storeId: this.storeData.id },
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const today = new Date().toISOString().split("T")[0];

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", `ventas-${today}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch (err) {
        return { success: false, data: err.response };
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style scoped>
.btn_export {
  @apply mt-5 border rounded-md border-indigo-700 text-indigo-700 px-5 py-2 cursor-pointer;
}
.btn_export:hover {
  @apply border-green-500 text-green-500;
}
</style>
